<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent" v-if="!isModal"></column-header>
    <div :class="bodyClassName + ' tabulator-parent'">
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-tags"></i> {{ _('Tags') }}</h3>
        </div>
      </div>
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition name="fade" mode="out-in">
          <div v-bind="tabPanel('tags')" class="tab-pane active" id="tags" v-if="isTabActive('tags')" key="tags">
            <div class="flex-row space-between">
              <div class="list-filter-row">
                <div class="filtercol">
                  <div class="form-group">
                    <div class="input-group">
                      <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
                      <span class="input-group-btn">
                        <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="filtercol">
                  <select class="form-control" v-model="category">
                    <option value="">{{ _('All tags') }}</option>
                    <option value="product">{{ _('Product') }}</option>
                    <option value="category">{{ _('Category') }}</option>
                    <option value="seo">{{ _('SEO') }}</option>
                    <option value="order">{{ _('Order') }}</option>
                    <option value="admin">{{ _('Admin') }}</option>
                    <option value="delivery">{{ _('Delivery method') }}</option>
                  </select>
                </div>
              </div>
              <button class="newSelector btn btn-success addbutton" type="button" v-on:click="addTagDialog()"><i class="fa fa-fw fa-plus"></i> {{ _('Create new...') }}</button>
            </div>
            <Datatable :url="tagsUrl" :search="search" :type-filter="category" :options="tableOptions" ref="datatableTags" v-on:data="tableEvent" :style="isModal ? 'height: 70dvh; min-height: 200px;' : ''" />
          </div>
        </transition>
      </div>
    </div>
    <nav class="modal-footer" v-if="isModal">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right">
            <button class="btn btn-default" v-on:click="close"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import components from '~/lib/components'
import formatters from '~/lib/formatters'
import tags from '~/lib/tags'
import { Datatable } from '#components'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      search: '',
      activeTab: 'tags',
      category: '',
      tableOptions: {
        fixWidths: true,
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Title'),
          field: 'title',
          widthGrow: 3,
          responsive: 0
        },
        {
          title: _('Type'),
          field: 'category',
          widthGrow: 2,
          formatter: this.tagTypeFormatter()
        },
        {
          title: _('Language'),
          field: 'locale',
          widthGrow: 2,
          formatter: this.tagLanguageFormatter()
        }
        ],
        initialSort: [{
          column: 'title',
          dir: 'asc'
        }],
        rowClick (e, row) {
          const id = row.getCell('id').getValue()
          const title = row.getCell('title').getValue()
          $this.editTag(id, title)
        }
      }
    }
  },
  mixins: [components, formatters, tags],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'tags', label: this._('Tags') }
      ])
    },
    tagsUrl () {
      return this.baseDomain + this.shopId + '/tags.json?apikey=' + this.apiKey
    },
  },
  methods: {
    reload () {
      if (this.$refs.datatableTags) {
        this.$refs.datatableTags.reload()
      }
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if (this.component && this.component.initData && this.component.initData.category) {
      this.category = this.component.initData.category
    }
    if(!this.events) {
      let events = {}
      events['tagUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>